<template>
    <d-card class="h-100">
        <d-card-header :class="{ 'border-bottom success': kizi }" class="border-bottom">kizi.nl</d-card-header>
        <d-card-body>
            <d-col class="d-flex justify-content-center">
                <img class="img-fluid" src="@/assets/images/kizi.png" alt="kizi">
            </d-col>
        </d-card-body>
        <d-col class="mb-3" v-if="create == true">
            <kizi-connect-form :website-id="websiteId" />
        </d-col>
        <d-card-footer v-else class="d-flex justify-content-center">
            <button v-if="kizi" @click="showForm" class="btn btn-secondary">Connected</button>
            <button v-else @click="connect" class="btn btn-success">Connect</button>
        </d-card-footer>
    </d-card>
</template>

<script>
    import KiziConnectForm from '@/views/integrations/kizi/ConnectForm.vue'
    import {ErrorService, KiziNLIntegration} from "@/main";
    import * as Sentry from "@sentry/browser";
    import notification from "@/mixins/notification";

    export default {
        props: ['kizi'],

        components: {
            KiziConnectForm,
        },
        mixins: [notification],

        data() {
            return {
                create: false,
                websiteId: this.$route.params.id
            };
        },

        methods: {
            showForm() {
                this.create = true
            },

            async connect() {
                try {
                    await KiziNLIntegration.connect(this.websiteId)

                    this.showNotification('success', 'Alert', 'Kizi.NL successfully connected!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
        },

        created() {
            this.isUpdate = !!this.kizi
        },

        beforeUpdate() {
            if (! this.isUpdate) {
                this.isUpdate = !!this.kizi // for already storing show update form
            }
        }
    };
</script>
